import React from "react";

import { RushaSvgIcon } from "./RushaSvgIcon";

/**
 * Push / upload icon.
 *
 * An upload arrow (arrow pointing up) with a base line at the bottom.
 * Represents pushing an image/artifact to a registry.
 *
 * Dual-tone layered:
 * - Outlines: currentColor, 2px stroke, round caps/joins
 * - Arrow: cyan accent fill at 8%
 */
export const PushIcon: React.FC<{ size?: number }> = ({ size = 24 }) => (
  <RushaSvgIcon size={size}>
    {/* Upward arrow shaft with cyan accent fill */}
    <path
      d="M12 4 L12 16"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    {/* Arrow head with cyan accent fill */}
    <path
      d="M7 9 L12 4 L17 9"
      fill="#00d4ff"
      fillOpacity={0.08}
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    {/* Base line at the bottom */}
    <path
      d="M4 20 L20 20"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </RushaSvgIcon>
);

PushIcon.displayName = "PushIcon";

export default PushIcon;
